var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { StandardLayout } from 'hx-ui';
import { Divider } from '@/components/divider.component';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from 'hx-util';
import { palette } from '@/theme/palette';
import { Button } from '@mui/material';
import { AnimatedCircles } from 'hx-ui';
export function InstructionsStep() {
    return (_jsx(StandardLayout, { header: _jsxs("div", __assign({ className: "flex flex-col items-center justify-center pt-16 gap-y-6 px-4" }, { children: [_jsx(Typography, __assign({ variant: "h2", className: "md:text-[41px] text-3xl" }, { children: "Hearing test instructions" })), _jsx(Divider, { className: 'w-full md:hidden' }), _jsxs("div", __assign({ className: 'flex flex-col gap-y-4 items-center justify-center' }, { children: [_jsxs(Typography, __assign({ variant: "subhead", className: "text-base sm:text-xl" }, { children: ["We will play ", _jsx("span", __assign({ className: 'font-bold' }, { children: "3 numbers" })), " with background noise."] })), _jsxs(Typography, __assign({ variant: "subhead", className: "text-base sm:text-xl" }, { children: ["Enter the numbers you hear in order and press", ' ', _jsx("span", __assign({ className: 'font-bold' }, { children: "OK." }))] })), _jsx(Typography, __assign({ variant: "subhead", className: "text-base sm:text-xl" }, { children: "It's ok to guess if you can't hear clearly." }))] }))] })), content: _jsx(MainContent, {}) }));
}
function MainContent() {
    var _a = useState('START'), buttonText = _a[0], setButtonText = _a[1];
    var navigate = useNavigate();
    function onClick() {
        if (buttonText !== 'START')
            return;
        var currentCount = 5;
        setButtonText("".concat(currentCount));
        var timerId = setInterval(function () {
            currentCount--;
            if (currentCount > 0) {
                setButtonText("".concat(currentCount));
                return;
            }
            clearInterval(timerId);
            navigate('/din-test');
        }, 1000);
    }
    return (_jsx("div", __assign({ className: 'flex justify-center items-center w-full h-full py-32' }, { children: _jsx(AnimatedButton, __assign({ onClick: onClick, duration: 5 }, { children: _jsx("span", __assign({ className: cn('text-2xl text-white font-bold', {
                    'text-4xl': buttonText !== 'START',
                }) }, { children: buttonText })) })) })));
}
export function AnimatedButton(_a) {
    var children = _a.children, onClick = _a.onClick, duration = _a.duration;
    function colorTransform(index) {
        var colors = [
            palette.primary.main,
            palette.primary.main,
            palette.primary.main,
        ];
        return colors[index];
    }
    function opacityTransform(index) {
        return 0.7 - 0.2 * index;
    }
    return (_jsx(AnimatedCircles, __assign({ duration: duration, color: palette.common.black, colorTransform: colorTransform, opacityTransform: opacityTransform }, { children: _jsx(Button, __assign({ onClick: onClick, className: 'rounded-full h-28 w-28 min-w-full' }, { children: children })) })));
}
